import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Contact } from "./components/contact";
import { PagCalcImc } from "./components/PagCalcImc";
import { Medicos } from "./components/medicos";
import { RicardoBarbuti } from "./components/ricardoBarbuti";
import { HelenaAtroch } from "./components/helenaAtroch";
import { LucaBarbuti } from "./components/lucaBarbuti";
import { DoencasEndocrino } from "./components/deoncasEnd";
import { DoencasGastro } from "./components/doencasGast";
import { Calculadoras } from "./components/calculadoras";
import { PagCalcFib4 } from "./components/pagCalcFib4";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import FloatingButtons from "./components/FloatingButtons";
import "./App.css";
import "./styles/style.css"

/* Smooth Scroll */
export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
  offset: 80,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <BrowserRouter>
      <FloatingButtons />
      <Routes>

        {/* ============================
             ROTA 1 — LANDING PAGE "/"
         ============================ */}
        <Route
          path="/"
          element={
            <>
              <div id="page-top"></div>

              <Navigation />
              <Header data={landingPageData.Header} />
              <Features data={landingPageData.Features} />
              <About data={landingPageData.About} />
              <Gallery data={landingPageData.Gallery} />
              <Testimonials data={landingPageData.Testimonials} />
              <Contact data={landingPageData.Contact} />
            </>
          }
        />

        {/* ============================
             ROTA 2 — CALCULADORA IMC
         ============================ */}
        <Route path="/calculadora-imc" element={<PagCalcImc />} />
        {/* ============================
             ROTA 3 — MÉDICOS
         ============================ */}
        <Route path="/medicos" element={<Medicos />} />
        {/* ============================
             ROTA 4 — RICARDO BARBUTI
         ============================ */}
        <Route path="/ricardo-barbuti" element={<RicardoBarbuti />} />
        {/* ============================
             ROTA 5 — HELENA ATROCH
         ============================ */}
        <Route path="/helena-atroch" element={<HelenaAtroch />} />
        {/* ============================
             ROTA 6 — LUCA BARBUTI
         ============================ */}
        <Route path="/luca-barbuti" element={<LucaBarbuti />} />
        {/* ============================
             ROTA 7 — DOENÇAS
         ============================ */}
        <Route path="/doencas-endocrino" element={<DoencasEndocrino />} />
        {/* ============================
             ROTA 8 — DOENÇAS
         ============================ */}
        <Route path="/doencas-gastro" element={<DoencasGastro />} />
        {/* ============================
             ROTA 9 — CALCULADORAS
         ============================ */}
        <Route path="/calculadoras" element={<Calculadoras />} />
        {/* ============================
             ROTA 10 — CALCULADORA FIB-4
         ============================ */}
        <Route path="/calculadora-fib4" element={<PagCalcFib4 />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
